import React from 'react'
import { observer } from 'mobx-react-lite'

import TextField from '@mui/material/TextField'

import { Dialog, useGlobalCopyStore, useScreenSize, useUserStore } from '../../common'

interface ManageCreditScoreProps {
  isOpen: boolean
  onClose: () => void
}

const ManageCreditScore = ({ isOpen, onClose }: ManageCreditScoreProps) => {
  const { common: commonCopy, finstrong: finstrongCopy } = useGlobalCopyStore()
  const { isMobile } = useScreenSize()
  const { updateUser, user } = useUserStore()

  const [creditScore, setCreditScore] = React.useState<number>(user.credit_score || 0)

  const isValid = !isNaN(creditScore)

  const handleClose = () => {
    onClose()
    setTimeout(() => setCreditScore(user.credit_score || 0), 300)
  }

  const handlePrimaryAction = () => {
    if (!creditScore || creditScore === user.credit_score) return
    updateUser({ ...user, credit_score: creditScore })
  }

  return (
    <Dialog
      copy={{ close_aria: commonCopy.close_aria, title: finstrongCopy.edit_credit_score }}
      disablePrimaryButton={!creditScore || !isValid}
      isOpen={isOpen}
      maxWidth="xs"
      onClose={handleClose}
      onPrimaryAction={handlePrimaryAction}
      primaryColor="primary"
      primaryText={commonCopy.save_button}
      sx={{
        '& .MuiDialog-paper': {
          minWidth: isMobile ? '100%' : 400,
        },
      }}
    >
      <form
        onSubmit={(e) => {
          e.preventDefault()
          handlePrimaryAction()
          handleClose()
        }}
      >
        <TextField
          error={!isValid}
          fullWidth={true}
          inputMode="numeric"
          onChange={(e) => setCreditScore(Number(e.target.value))}
          slotProps={{
            htmlInput: {
              noValidate: true,
              pattern: '[0-9]*',
            },
          }}
          value={isValid ? creditScore : ''}
        />
      </form>
    </Dialog>
  )
}

export default observer(ManageCreditScore)
